export default function CTA() {
  return (
    <section className="py-20 md:py-32 px-4 bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 bg-gradient-to-r from-teal-600/20 via-transparent to-yellow-500/20"></div>
      <div className="absolute top-10 left-10 w-32 h-32 bg-teal-500/10 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-10 right-10 w-40 h-40 bg-yellow-500/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      
      <div className="container mx-auto max-w-5xl text-center relative z-10">
        {/* Selo de Garantia */}
        <div className="mb-12">
          <div className="bg-green-500 rounded-full p-8 w-32 h-32 mx-auto mb-8 flex items-center justify-center">
            <i className="ri-shield-check-line text-4xl text-white"></i>
          </div>
          <h2 className="text-4xl md:text-6xl font-black mb-6">
            Garantia Incondicional<br />
            de <span className="text-yellow-400">7 Dias</span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed mb-8 max-w-4xl mx-auto">
            Você tem 7 dias para testar o CalculaDP com total tranquilidade. 
            Se não gostar, devolvemos <strong className="text-white">100% do seu dinheiro</strong> sem perguntas, 
            sem burocracia. A confiança é nossa, o risco é todo nosso.
          </p>
          
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-12 border border-white/20">
            <h3 className="text-2xl font-bold mb-6">Como funciona:</h3>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="bg-teal-600 rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-4">
                  <span className="text-xl font-bold">1</span>
                </div>
                <h4 className="font-bold mb-2">Faça seu cadastro</h4>
                <p className="text-gray-300 text-sm">Escolha seu plano e acesse imediatamente</p>
              </div>
              <div className="text-center">
                <div className="bg-teal-600 rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-4">
                  <span className="text-xl font-bold">2</span>
                </div>
                <h4 className="font-bold mb-2">Teste</h4>
                <p className="text-gray-300 text-sm">Use todas as funcionalidades</p>
              </div>
              <div className="text-center">
                <div className="bg-teal-600 rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-4">
                  <span className="text-xl font-bold">3</span>
                </div>
                <h4 className="font-bold mb-2">Não gostou? Devolvemos tudo</h4>
                <p className="text-gray-300 text-sm">100% do valor de volta, sem complicação</p>
              </div>
            </div>
          </div>
          
          <p className="text-2xl md:text-3xl font-bold mb-12">
            Você tem <span className="text-yellow-400">tudo a ganhar</span> e <span className="text-green-400">nada a perder</span>.<br />
            Agora a decisão é sua!
          </p>
        </div>

        {/* Urgência e Escassez */}
        <div className="bg-red-600 rounded-2xl p-8 mb-12 border-2 border-red-400">
          <div className="flex items-center justify-center gap-4 mb-6">
            <i className="ri-fire-line text-3xl animate-pulse"></i>
            <h3 className="text-2xl md:text-3xl font-bold">
              ÚLTIMAS HORAS DA PROMOÇÃO!
            </h3>
            <i className="ri-fire-line text-3xl animate-pulse"></i>
          </div>
        </div>

        {/* Oferta Final */}
        <div className="bg-gradient-to-r from-teal-600 to-cyan-600 rounded-3xl p-8 md:p-12 border-2 border-yellow-400">
          <h3 className="text-3xl md:text-4xl font-black mb-6">
            🔥 OFERTA ESPECIAL POR TEMPO LIMITADO
          </h3>
          
          <div className="grid md:grid-cols-2 gap-8 items-center mb-8">
            <div>
              <div className="text-gray-200 line-through text-2xl mb-2">De R$39,99</div>
              <div className="text-5xl md:text-6xl font-black text-yellow-300 mb-2">
                R$ 24,92/mês
              </div>
              <div className="text-xl text-gray-200">12 meses por apenas 299,00 no plano premium anual</div>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
              <h4 className="text-xl font-bold mb-4">✅ Você recebe TUDO:</h4>
              <ul className="text-left space-y-2 text-sm">
                <li>✓ 1 ano de acesso completo</li>
                <li>✓ Cálculos ilimitados</li>
                <li>✓ Relatórios com sua logo</li>
                <li>✓ Todos os tipos de cálculo</li>
                <li>✓ Suporte prioritário</li>
                <li>✓ Atualizações gratuitas</li>
                <li>✓ <strong>Garantia de 7 dias</strong></li>
              </ul>
            </div>
          </div>

          {/* CTA Button */}
          <button 
            className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 px-12 py-6 rounded-2xl text-2xl font-black shadow-2xl hover:shadow-3xl transition-all transform hover:scale-105 mb-6 whitespace-nowrap"
            onClick={() => window.open('https://calculadp.tiagonogueira.com.br/ponto', '_blank')}
          >
            <i className="ri-secure-payment-line mr-3"></i>
            GARANTIR MEU ACESSO AGORA
          </button>
          
          <div className="flex items-center justify-center gap-8 text-sm text-gray-200">
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-green-400"></i>
              <span>Pagamento 100% Seguro</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-time-line text-yellow-400"></i>
              <span>Acesso Imediato</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-medal-line text-green-400"></i>
              <span>7 Dias de Garantia</span>
            </div>
          </div>
        </div>

        {/* Último apelo */}
        <div className="mt-12 text-center">
          <p className="text-lg text-gray-300 mb-6 max-w-3xl mx-auto italic">
            "Não deixe para amanhã o que pode mudar sua vida hoje. 
            Centenas de contadores, profissionais de DP e RH já transformaram 
            sua rotina com o CalculaDP."
          </p>
          <p className="text-xl font-bold text-yellow-400">
            A pergunta é: você vai continuar perdendo tempo e dinheiro com erros,<br />
            ou vai se juntar aos profissionais que já evoluíram?
          </p>
        </div>
      </div>
    </section>
  );
}
